module.exports = __webpack_public_path__ + "media/images/home/ic_view-50627b1f10c549212eebbc0c7a46a870.svg";